import { Button, MenuItem, Position } from "@blueprintjs/core";
import React, { useRef } from "react";
import { Suggest } from "@blueprintjs/select";
import "styled-components/macro";

const ENTER_RETURN_KEY_CODE = 13;

export type EmailAddress = string;

export const EmailAddressS = Suggest.ofType<EmailAddress>();

export function EmailAddressInput({
  queryText,
  setQueryText,
  selectedItem,
  onSelect,
  onClear,
  activeField,
  setActiveField,
  defaultOptions,
}) {
  const emailAddressInputRef = useRef(null);

  const handleFocus = () => {
    emailAddressInputRef.current && emailAddressInputRef.current.focus();
    setActiveField("emailAddress");
  };

  const isItemSelected = (r) => selectedItem === r;
  const onItemSelect = (emailAddress) => {
    const itemIsSelected = isItemSelected(emailAddress);
    console.log(
      "src/components/reporting-actions/ecp--email-address-input.tsx",
      { itemIsSelected, emailAddress, selectedItem }
    );
    if (itemIsSelected) {
      onClear();
    } else {
      onSelect(emailAddress);
    }
  };
  // const onItemsSelect = (emailAddress) => emailAddress.map(onItemSelect);

  return (
    <div
      css={`
        .bp3-multi-select-popover .bp3-menu {
          //max-width: none !important;
          max-height: 220px !important;
          overflow-y: auto;
        }
      `}
    >
      <EmailAddressS
        fill
        inputValueRenderer={(v) => v}
        createNewItemFromQuery={undefined}
        onKeyDown={(ev) => {
          if (ev.keyCode === ENTER_RETURN_KEY_CODE) {
            ev.preventDefault();
          }
        }}
        resetOnSelect={false}
        createNewItemRenderer={null}
        openOnKeyDown={false}
        items={defaultOptions}
        itemDisabled={isItemSelected}
        itemPredicate={emailAddressPredicate}
        itemRenderer={emailAddressItemRenderer(isItemSelected)}
        selectedItem={selectedItem}
        onItemSelect={onItemSelect}
        tagRenderer={emailAddressTagRenderer}
        placeholder=""
        query={queryText}
        onQueryChange={setQueryText}
        // onFocus={handleFocus}
        popoverProps={{
          usePortal: false,
          minimal: true,
          position: Position.BOTTOM_LEFT,
        }}
        inputProps={{
          onFocus: handleFocus,
          name: "emailAddress",
          autoFocus: true,
          inputRef: (r) => {
            emailAddressInputRef.current = r;
          },
          leftIcon: "envelope",
          large: true,
          onRemove: onClear,
        }}
        // TODO: Center for IE11
        // css={`
        //   .bp3-popover-content .bp3-menu {
        //     width: ${width}px;
        //   }
        // `}
      />
    </div>
  );
}

const emailAddressPredicate = (
  query,
  emailAddress: EmailAddress,
  _index,
  exactMatch
) => {
  const normalizedTitle = emailAddress.toLowerCase();
  const normalizedQuery = query.toLowerCase();

  if (exactMatch) {
    return normalizedTitle === normalizedQuery;
  } else {
    return normalizedTitle.includes(normalizedQuery);
  }
};
const emailAddressTagRenderer = (emailAddress: EmailAddress) => emailAddress;
const emailAddressItemRenderer =
  (isItemSelected) =>
  (emailAddress: EmailAddress, { modifiers, handleClick }) => {
    if (!modifiers.matchesPredicate) {
      return null;
    }
    const isSelected = isItemSelected(emailAddress);
    return (
      <MenuItem
        active={modifiers.active}
        icon={isSelected ? "tick" : "blank"}
        disabled={false}
        key={emailAddress}
        text={emailAddress}
        // label={emailAddress.longName}
        onClick={handleClick}
        shouldDismissPopover={false}
      />
    );
  };
